function filterCepResults(payload) {
    const { clientId, data } = payload;
    const { body, channel, stage } = data;
    const {
        error,
        progress,
        routeDate,
        schedulerTaskId,
        preschedulerSolutionInfo: solutionInfo
    } = body;

    return {
        clientId,
        channel,
        error,
        progress,
        routeDate,
        schedulerTaskId,
        solutionInfo,
        stage
    };
}

export default {
    filterCepResults
};
